
import keyMirror from '../utils/keyMirror';

export const messageTypes = keyMirror(
  'subscribeToStats',
  'stats',
  'containerStatus'
)
